module.exports = __webpack_public_path__ + "statics/img/3-3.ceb8c9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/product/icon/3-3.png
// module id = 01Pk
// module chunks = 1